import { Component, Input, OnInit } from '@angular/core';
import { UserOnboardingService } from '../../../public/user-onboarding/user-onboarding.service';
import { SharedService } from '../../../shared/shared.service';
import { ProfileService } from '../../profile.service';
import { User } from '../../types/user.model';

@Component({
  selector: 'mmb-web-app-profile-highlights-section',
  templateUrl: './profile-highlights-section.component.html',
  styleUrls: ['./profile-highlights-section.component.scss']
})
export class ProfileHighlightsSectionComponent implements OnInit {
  @Input() user: User;
  personas: any[];
  seniorities: any[];
  userCountryConnections: any[];
  selectedIndustries: any[];
  
  constructor(private sharedService: SharedService, private userOnboardingService: UserOnboardingService,
    private profileService: ProfileService) { }

  ngOnInit() {
    this.sharedService.referenceTypes$.subscribe((value) => {
      if (value) {
        this.seniorities = value.type_reference_user_profile_seniority;
      }
    })

    this._getPersonaOptions();
    this._getUserCountryConnections();
    this._getUserIndustries();
  }

  getSeniority(id: number) {
    return this._findValueById(this.seniorities, id);
  }

  getPersona(id: number) {
    return this._findItemById(this.personas, id);
  }

  private _getUserIndustries() {
    this.userOnboardingService.getUserPrimaryIndustry().subscribe((response) => {
      this.selectedIndustries = response;
    });
  }

  private _getUserCountryConnections() {
    this.profileService.getUserInternational().subscribe(res => {
      this._mapCountriesConnections(res);
    });
  }

  private _mapCountriesConnections(connections: any[]) {
    let connectionsBuffer = [];
    for (let connection of connections) {
      if (!connectionsBuffer[connection.country.id]) {
        connectionsBuffer[connection.country.id] = {
          country: connection.country,
          uuid: connection.uuid,
          country_statuses: []
        };
      }

      connection.country_status.recordUuid = connection.uuid;
      connectionsBuffer[connection.country.id].country_statuses.push(connection.country_status);
    }
    this.userCountryConnections = connectionsBuffer;
  }

  private _getPersonaOptions() {
    this.userOnboardingService.getUserProfileReferenceType().subscribe((response) => {
      this.personas = response;
    })
  }

  private _findItemById(items: any[], id: any) {
    return items ? items.find((item) => item.value === id) : null;
  }

  private _findValueById(items: any[], id: any) {
    let foundItem = items ? items.find((item) => item.value === id) : null;
    if (foundItem) {
      return foundItem.name;
    }
    return null;
  }
}
